// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import {jwtDecode} from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { DecodedToken } from '../models/decoded-token';
import { AuthService } from './auth.service';

export interface LoginResponse {
  token: string;
  refreshToken: string;
}



@Injectable({
  providedIn: 'root'
})
export class AccessManagerService {
  private apiUrl = `${environment.legalAssureApiBaseUrl}`;
  private jwtToken: string | null = null;
  private refreshTokenValue: string | null = null;
  private logoutTimer: any;

  private userSubject = new BehaviorSubject<DecodedToken | null>(null);
  currentUser$ = this.userSubject.asObservable();

  constructor(private authService:AuthService) {
  }

  getUserRoles(){
    debugger;
    const token = this.authService.getAccessToken();
    //const decodedToken = this.authService.decodeToken(token as string);
    const decodedToken = [];
    if(decodedToken)
    {
      //const access = JSON.parse(decodedToken.access);
      return [];
    }
    return null;
  }

}
